<div class="bg-(--bg-color) rounded-4xl p-6 shadow-lg w-auto sm:max-w-md md:max-w-[532px] z-55 text-center mx-auto">
  <!-- Cancel Icon -->
  <img src="assets/icons/cancel.svg" alt="Cancel Icon" class="modal-close-icon rtl:mr-auto! rtl:ml-0!" (click)="close()" />

  <!-- Header Icon -->
  <img [src]="options?.headerIconPath" alt="Mail Icon" class="mb-6 mx-auto w-20 h-20" />

  <!-- Title -->
  <h3 class="mb-8 text-(--text-primary) font-semibold text-[20px] leading-[26px]">
    {{ options.title | translate }}
  </h3>

  <!-- Message -->
  <p class="mb-5 text-(--text-primary) max-w-60 mx-auto text-center font-medium leading-6 text-base">
    {{
    options.mobile
    ? ('OTP_MODAL.MESSAGE_MOBILE' | translate:{ mobile: options.mobile })
    : ('OTP_MODAL.MESSAGE_EMAIL' | translate:{ email: options.email })
    }}
  </p>


  <!-- OTP Input -->
  <form [formGroup]="otpForm" (ngSubmit)="submitOtp()">
    <div class="flex justify-center mb-9">
      <ng-otp-input [formControl]="otpForm.controls['otp']" [config]="{
          length: 6,
          inputClass: 'otp-input',
          allowNumbersOnly: true,
          isPasswordInput: true,
          disableAutoFocus: false,
          inputStyles: {
            width: '40px',
            height: '50px',
            borderRadius: '12px',
            border: 'none',
            fontSize: '20px',
            textAlign: 'center',
            color: '#1C1E1F',
            boxShadow: '0px 2px 6px 0px #0000001A',
          }
        }" (onInputChange)="onOtpChange($event)">
      </ng-otp-input>
    </div>

    <!-- Timer + Resend -->
    <div class="text-(--text-muted) mb-6 font-medium text-base leading-6">
      <span *ngIf="timer() > 0">
        {{'OTP_MODAL.RESEND_TEXT' | translate}}
        <span class="text-(--text-secondary)">{{ formattedTimer }}</span>
      </span>
      <button *ngIf="timer() === 0" type="button" (click)="resendCode()"
        class="text-(--text-link) font-medium hover:opacity-80 cursor-pointer">
        {{ 'OTP_MODAL.RESEND_BUTTON' | translate }}
      </button>
    </div>

    <!-- Confirm Button -->
    <app-button *ngIf="options?.showConfirmButton" [text]="options.textConfirmButton | translate" variant="primary"
      [disabled]="!isOtpComplete" size="lg" (action)="submitOtp()">
    </app-button>
  </form>
</div>